import { render, staticRenderFns } from "./personalform.vue?vue&type=template&id=6a5d1805&scoped=true&"
import script from "./personalform.vue?vue&type=script&lang=js&"
export * from "./personalform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5d1805",
  null
  
)

export default component.exports